"use client";

import { ComponentProps } from "react";

import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

import { useHoverPopover } from "./use-hover-popover";

type Props = {
  className?: string;
  align?: ComponentProps<typeof PopoverContent>["align"];
};

export function AdvertisingDisclosure({ className, align = "start" }: Props) {
  const { open, onOpenChange, hoverHandlers } = useHoverPopover();

  return (
    <Popover
      open={open}
      onOpenChange={onOpenChange}
    >
      <PopoverTrigger
        asChild
        className={className}
        {...hoverHandlers}
      >
        <Button
          variant="link"
          className="group p-0 h-6"
        >
          <span className="body3 underline text-text-grayscale-body lg:group-hover:text-primary-hover transition-colors">
            Advertising Disclosure
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align={align}
        className="w-[min(19.75rem,calc(100vw-2rem))] sm:w-[min(31.25rem,calc(100vw-2rem))]"
        {...hoverHandlers}
      >
        <div className="flex flex-col gap-2">
          <p className="body3 text-text-grayscale-body">
            Our rankings are generated through the algorithmic analysis of
            thousands of customer reviews about products, brands, merchant
            customer service levels, popularity trends, and more. We use
            advanced technology, including AI, to help process and organize this
            information at scale, supporting our analysis with greater speed and
            consistency. The rankings reflect our opinion and should be a good
            starting point for shopping.
          </p>
        </div>
      </PopoverContent>
    </Popover>
  );
}
